import { Button, Grid, Paper, Typography } from "@mui/material";
import { Formik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import FormikCheckbox from "../../../commons/formik/FormikCheckbox";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CircularLoading from "../../../commons/loading/CircularLoading";
import ResponsablesCard from "../../../commons/responsables/responsablesCard/ResponsablesCard";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import { StyledResolucion } from "../../../styled/Prevencion";
import { cabeceraValidation } from "../validation/formValidation";

const CabeceraForm = ({
  handleSubmit,
  handleCancelForm,
  handleOpenDialog,
  formModel,
  establecimiento,
}) => {

  const calcularTotalTrabajadores = (values) => {
    return (
      (parseInt(values.cantidadTrabajadoresProduccion) || 0) +
      (parseInt(values.cantidadTrabajadoresEventualesProduccion) || 0) +
      (parseInt(values.cantidadTrabajadoresAdministracion) || 0) +
      (parseInt(values.cantidadTrabajadoresEventualesAdministracion) || 0)
    );
  };

  // Necesitamos una función aparte, porque si algún campo de trabajadores
  // presenta errores, no podemos hacer simplemente parseInt(camposTrabajadores).
  // Esto llevaría a errores, como mostrar el Total en -11, o en null.
  const handleGetTotalTrabajadores = (valores, errores) => {
    if (
      errores.cantidadTrabajadoresAdministracion ||
      errores.cantidadTrabajadoresProduccion ||
      errores.cantidadTrabajadoresEventualesAdministracion ||
      errores.cantidadTrabajadoresEventualesProduccion
    ) {
      return "ERROR";
    }

    return calcularTotalTrabajadores(valores);
  };

  return (
    <>
      {formModel ? (
        <Formik
          initialValues={formModel}
          onSubmit={(values) => {
            let totalTrabajadores = calcularTotalTrabajadores(values);
            if (totalTrabajadores > 0) {
              handleSubmit(values);
            } else {
              toast.error(
                "Es necesario cargar al menos un trabajador para poder avanzar al siguiente paso."
              );
            }
          }}
          validationSchema={cabeceraValidation}
          enableReinitialize={true}
        >
          {({ values, errors }) => (
            <StyledResolucion.Form
              style={{ alignItems: "center" }}
            >
              {/* Parte 1: Datos sobre la presentación de la resolución */}
              <StyledResolucion.DatosPresentacion>
                <StyledResolucion.Label>
                  <strong style={{ marginRight: 5 }}>
                    Fecha de Presentación:
                  </strong>
                  {moment(new Date()).format("DD/MM/YYYY")}
                </StyledResolucion.Label>
                <StyledResolucion.Label>
                  <strong style={{ marginRight: 5 }}>
                    Motivo de Presentación:
                  </strong>
                  Presentación Anual
                </StyledResolucion.Label>
                <StyledResolucion.LabelActividad>
                  <strong>Actividad Principal de la Empresa:</strong>
                  {establecimiento?.actividadEmpleador}
                </StyledResolucion.LabelActividad>
                <StyledResolucion.LabelActividad>
                  <strong>Actividad Principal del Establecimiento:</strong>
                  {establecimiento?.actividad}
                </StyledResolucion.LabelActividad>
              </StyledResolucion.DatosPresentacion>
              {/* Parte 2: Subformulario sobre trabajadores */}
              <Paper>
                <Grid container style={{ padding: 20 }} spacing={2}>
                  <Grid item xs={6}>
                    <FormikTextField
                      fullWidth
                      id="cantidadTrabajadoresProduccion"
                      name="cantidadTrabajadoresProduccion"
                      type="number"
                      label="Cantidad de Trabajadores en Producción *"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      fullWidth
                      id="cantidadTrabajadoresEventualesProduccion"
                      name="cantidadTrabajadoresEventualesProduccion"
                      type="number"
                      label="Cantidad de Trabajadores Eventuales en Producción *"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      fullWidth
                      id="cantidadTrabajadoresAdministracion"
                      name="cantidadTrabajadoresAdministracion"
                      type="number"
                      label="Cantidad de Trabajadores en Administración *"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField
                      fullWidth
                      id="cantidadTrabajadoresEventualesAdministracion"
                      name="cantidadTrabajadoresEventualesAdministracion"
                      type="number"
                      label="Cantidad de Trabajadores Eventuales en Administración *"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      <strong>Total Trabajadores:</strong>{" "}
                      {handleGetTotalTrabajadores(values, errors)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              {/* Parte 3: Espacios y habilitaciones fumadores en establecimiento */}
              <StyledResolucion.FumarEstablecimiento>
                <FormikCheckbox
                  name="sePuedeFumar"
                  label="Se puede fumar en el Establecimiento"
                />
                <FormikCheckbox
                  name="espacioParaFumar"
                  label="Posee espacio para Fumar"
                />
              </StyledResolucion.FumarEstablecimiento>
              <StyledResolucion.DatosResponsables>
                <ResponsablesCard
                  name="contacto"
                  responsableType={ResponsablesEnum.contactoEmpresa}
                  title="Contacto"
                  handleOpenAddResponsable={handleOpenDialog}
                  required
                />
                <ResponsablesCard
                  name="responsableEmpresa"
                  responsableType={ResponsablesEnum.representanteEmpleador}
                  title="Responsable de la Empresa"
                  handleOpenAddResponsable={handleOpenDialog}
                  required
                />
                <ResponsablesCard
                  name="responsableMedicina"
                  responsableType={ResponsablesEnum.representanteMedicinaLaboral}
                  title="Responsable de Medicina Laboral"
                  handleOpenAddResponsable={handleOpenDialog}
                />
                <ResponsablesCard
                  name="responsableSH"
                  responsableType={ResponsablesEnum.seguridadHigiene}
                  title="Responsable de Seguridad e Higiene"
                  handleOpenAddResponsable={handleOpenDialog}
                />
              </StyledResolucion.DatosResponsables>
              <StyledResolucion.ButtonContainer>
                <StyledResolucion.CancelButton
                  variant="contained"
                  onClick={handleCancelForm}
                >
                  CANCELAR FORMULARIO
                </StyledResolucion.CancelButton>
                <Button color="primary" type="submit" variant="contained">
                  SIGUIENTE
                </Button>
              </StyledResolucion.ButtonContainer>
            </StyledResolucion.Form>
          )}
        </Formik>
      ) : (
        <>
          <CircularLoading />
        </>
      )}
    </>
  );
};

export default CabeceraForm;
